<template>
  <div class="transition">
    <div class="transition-items">
      <div class="icon-items">
        <BasicIcon
          name="danger"
          active
        />
      </div>
      <BasicText v-for="(msg, index) in messages" :key="index">{{ msg }}</BasicText>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { CarteProps } from '@/features/interface/machine-etats/types.ts'
  import { computed } from 'vue'
  import type { InformationMessageIn } from './InformationMessage.type.ts'

  const props = defineProps<CarteProps<InformationMessageIn, void>>()

  const messages = computed(() => Array.isArray(props.in) ? props.in : [props.in])


</script>
<style lang="less" scoped>
  @import '../../ajouter/cartes/ChoixCarte.less';

  .icon-items {
    background-color: white;
    color: @warning-500;
    align-self: center;
    margin-bottom: 40px;
    svg {
      fill: @warning-500;
      transform: scale(3);
    }
  }
</style>
